module.exports = __webpack_public_path__ + "static/img/advantage2.a76630e2.png";